<div class="container">
  <form [formGroup]="firmanteForm">
    <table [style.display]="(destinatariosDropdown && destinatariosDropdown.length > 0 && busquedasDropdown && busquedasDropdown.length > 0) ? 'table' : 'none'">
      <tr>
        <td *ngIf="formularioEnvioService.ocultarOrden" class="orden td-orden">-</td>
        <td *ngIf="!formularioEnvioService.ocultarOrden" class="orden td-orden">{{i+1}}º</td>
        <div class="flex">
          <td class="td-drag">
            <svg class="icon-draggable">
              <use xlink:href="#icon-draggable"></use>
            </svg>
          </td>
          <div class="registro">
            <td class="td-firmante">
              <span class="text">
                {{firmante.tipoFirmante.desc}}
              </span>
            </td>
            <td *ngIf="mostrarFirmantePpal" class="td-destinatario">
              <app-drop-down-single-con-id [data]="[firmanteDestinatario]"
                                         (elementoSeleccionado)="onDestinatarioSeleccionado($event)"
                                         [valorPreSeleccionado]="destinatarioPreSeleccionado"
                                         [width]="'200px'"
                                         [height]="'30px'"
                                         [borderStyle]="'1px solid #D0D0D0'"
                                         [errorClass]="formularioValidacionesService.isCampoValidoArray('tipoDestinatario.codigo', i) ? 'errorInput':''">
              </app-drop-down-single-con-id>
              <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValidoArray('tipoDestinatario.codigo', i)">
                Requerido.
              </span>
            </td>
            <td *ngIf="!mostrarFirmantePpal" class="td-destinatario">
              <app-drop-down-single-con-id [data]="destinatariosDropdown"
                                           (elementoSeleccionado)="onDestinatarioSeleccionado($event)"
                                           [valorPreSeleccionado]="destinatarioPreSeleccionado"
                                           [width]="'200px'"
                                           [height]="'30px'"
                                           [borderStyle]="'1px solid #D0D0D0'"
                                           [errorClass]="formularioValidacionesService.isCampoValidoArray('tipoDestinatario.codigo', i) ? 'errorInput':''">
              </app-drop-down-single-con-id>
              <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValidoArray('tipoDestinatario.codigo', i)">
                Requerido.
              </span>
            </td>
            <td class="td-busqueda">
              <app-drop-down-single-con-id [data]="busquedasDropdown"
                                           (elementoSeleccionado)="onBusquedaSeleccionada($event)"
                                           [valorPreSeleccionado]="busquedaPreSeleccionado"
                                           [width]="'200px'"
                                           [height]="'30px'"
                                           [borderStyle]="'1px solid #D0D0D0'"
                                           [errorClass]="formularioValidacionesService.isCampoValidoArray('tipoBusqueda.codigo', i) ? 'errorInput':''">
              </app-drop-down-single-con-id>
              <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValidoArray('tipoBusqueda.codigo', i)">
                Requerido.
              </span>
            </td>
            <td class="td-eliminar">
              <span *ngIf="firmantePrincipalCodigo != firmante.tipoFirmante.codigo" class="eliminar" (click)="clicked()">
                <svg class="icon-bin">
                  <use xlink:href="#hs-bin"></use>
                </svg>
              </span>
              <span *ngIf="firmantePrincipalCodigo == firmante.tipoFirmante.codigo" class="no-eliminar">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </td>
          </div>
        </div>


      </tr>
    </table>
  </form>
</div>
